export default "__VITE_ASSET__YOisIh1$__";